export function resetPasswordErrorMessage(responseBody) {
    if (!responseBody || typeof responseBody !== 'object') {
        return 'Unable to reset password. Please try again.'
    }

    if (Array.isArray(responseBody.errors) && responseBody.errors.length > 0) {
        return responseBody.errors.filter(Boolean).join(' ')
    }

    if (typeof responseBody.error === 'string' && responseBody.error.trim()) {
        return responseBody.error
    }

    return 'Unable to reset password. Please try again.'
}
